
<script>
    import {createEventDispatcher} from "svelte";
    const dispatch = createEventDispatcher();

    export let label;
    export let note = null;
    export let selected = false;
    export let disabled = false;

    function selectHandler () {
        if (!disabled) {
            dispatch('select', {});
        }
    }

</script>

<style>
    .item {
        font-family: Roboto Condensed, sans-serif;
        text-transform: uppercase;
        font-weight: 400;
        padding: .5rem .7rem;
        min-height: 2.75rem;
        border: 1px solid var(--order-input-border-color);
        border-bottom: none;
        color: var(--order-input-text-color);
        background: var(--order-input-bg-color);
        transition: background .3s ease;
        cursor: pointer;
    }
    .item:first-child {
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }
    .item:last-child {
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
        border-bottom: 1px solid var(--order-input-border-color);
    }
    .item svg {
        background: inherit;
        transition: color .2s ease;
    }
    .item--selected {
        color: var(--bg-color);
        background: var(--accent-color);
    }
    .item--disabled {
        cursor: not-allowed;
    }
    .item--disabled svg,
    .item--disabled div {
        opacity: .35;
    }
    .item-note {
        font-size: .8em;
        opacity: .6;
    }
</style>

<div class="item flex gap-05 ai-center"
     class:item--selected={selected}
     class:item--disabled={disabled}
     on:click={selectHandler}>

    {#if (selected)}
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" stroke-width="2" class="ai ai-RadioFill"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"/></svg>
    {:else}
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Radio"><path d="M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z"/></svg>
    {/if}
    <div class="flex-fill">
        { label }
        {#if (note)}
            <div class="item-note">{ note }</div>
        {/if}
    </div>
</div>
